import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";

export default function NumberOfTests({ value, set }) {
  const { t } = useTranslation("translation");

  function renderInput() {
    return (
      <NumberFormat
        className={"change-input"}
        decimalScale={0}
        value={value}
        thousandSeparator={thousandSeparator()}
        decimalSeparator={decimalSeparator()}
        displayType="input"
        type="text"
        onValueChange={(value) => set(value.floatValue)}
        allowNegative={false}
      />
    );
  }

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.numberOfTests")}</p>}
      indicesValue={<p>n</p>}
      inputValue={renderInput()}
    />
  );
}
